import DialogCreateType from "../../../../components/Dialog/Create";
import TableSettings from "../../../../components/Table/Settings"
import { ColumnLabel } from "../../../../components/Table/Settings/Toolbar";
import { Dialog } from "@rio-cloud/rio-uikit";
import { createBranch, deleteBranch, editBranch, getBranch } from "../../../../services/form";
import { useEffect, useState } from "react";
import { Notification } from '@rio-cloud/rio-uikit';
import { getRegionalErrorMessage } from "../../../../utils/apiError";

const defaultColumnOrder = ['name'];

const columnLabels: ColumnLabel = {
  id: '1',
  name: "Regional",
  date: ''
};

interface IOptionsProps {
  id: number;
  name: string;
  date: string;
}

interface IOptionSelectedProps {
  id: number;
  name: string;
}

const BranchesPage = () => {
  const [createNewModal, setCreateNewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [options, setOptions] = useState<IOptionsProps[]>([]);
  const [optionSelected, setOptionSelected] = useState<IOptionSelectedProps>();

  const mountOption = (data: any[]) => {
    return data?.map((res: { id: number; name: string }) => {
      return {
        id: res.id,
        name: res.name,
        date: '',
      };
    });
  };
  
  const fetchOptions = async () => {
    try {
      const response = await getBranch();

      setOptions(mountOption(response));

    } catch (error) {
      console.log('error', error);
      setOptions([]);
    }
  }

  useEffect(() => {
    fetchOptions();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSaveNewOption = async (value: string) => {
    try {
      await createBranch({
          name: value,
      });
      fetchOptions();
      setCreateNewModal(false);
      Notification.success('Regional criada com sucesso.');
    } catch (error) {
      Notification.error(getRegionalErrorMessage(error, 'Não foi possível criar a regional no momento.'))
    }
  }

  const handleEditOption = async (value: string) => {
    if(!optionSelected?.id) return
    try {
      await editBranch({
        id: optionSelected?.id,
        name: value
      })
      fetchOptions();
      setEditModal(false);
      Notification.success('Regional alterada com sucesso.');
    } catch (error) {
      Notification.error(getRegionalErrorMessage(error, 'Não foi possível alterar a regional no momento.'))
    }
  }

  const handleDeleteOption = async (value: string) => {
    if(!optionSelected?.id) return
    try {
      await deleteBranch(optionSelected?.id)
      fetchOptions();
      setDeleteModal(false);
      Notification.success('Regional deletada com sucesso.');
    } catch (error) {
      Notification.error(getRegionalErrorMessage(error, 'Não foi possível deletar a regional no momento.'))
    }
  }

  return (
    <>
      <TableSettings
        data={options}
        totalData={options.length}
        columnLabels={columnLabels}
        defaultColumnOrder={defaultColumnOrder}
        viewType="TABLE"
        onLoadMore={(res) => console.log(res)}
        handleRefresh={() => {}}
        handleDownload={() => console.log('DOWNLOAD')}
        openModal={() => {setCreateNewModal(true);}}
        onEdit={(id, name) => {setOptionSelected({id, name}); setEditModal(true);}}
        onDelete={(id) => {setOptionSelected({id, name: ''}); setDeleteModal(true);}}
        onDeleteFile={() => {}}
        onGetFile={() => {}}
        onObservation={() => {}}
      />

      <DialogCreateType
        title='Nova regional'
        show={createNewModal}
        placeholder='Qual o nome da nova regional?'
        onClose={() => { setCreateNewModal(false); }}
        onSave={handleSaveNewOption}
      />
      
      <DialogCreateType
        title='Editar regional'
        show={editModal}
        placeholder='Qual o nome da nova regional?'
        onClose={() => { setEditModal(false); }}
        onSave={handleEditOption}
        editValue={optionSelected?.name}
      />

      <Dialog
        show={deleteModal}
        title={<span className='text-medium text-size-16'>Excluir regional</span>}
        body={
          <div className='padding-20'>
            <p>Tem certeza que deseja excluir esta regional?</p>
            <p className='text-color-danger'>Esta ação não pode ser desfeita.</p>
          </div>
        }
        footer={
          <div className='display-flex gap-10 justify-content-end'>
            <button
              className='btn btn-default'
              onClick={() => setDeleteModal(false)}
            >
              Cancelar
            </button>
            <button
              className='btn btn-danger'
              onClick={() => handleDeleteOption('')}
            >
              Excluir
            </button>
          </div>
        }
        onClose={() => setDeleteModal(false)}
        className='exampleDialog'
        showCloseButton
        bsSize='sm'
      />
    </>
  )
}

export default BranchesPage